import { GameReelsProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameReelsProperties";
/**
* ReelsLandscapeProperties.ts
*/
export class ReelsLandscapeProperties extends GameReelsProperties {
    constructor() {
        super();
        this.scale.set(0.73);
        this.position.set(703, 888);
    }
}
//# sourceMappingURL=ReelsLandscapeProperties.js.map